// extracted by mini-css-extract-plugin
export default {"container":"shopAdminHeader_container__R32NF"};